
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PostTrack, PutTrack, Track } from 'src/app/interfaces/api/track';
import { ApiService } from '../../core/api.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class TrackService {

  collection = "Track";
  collectionPath = "tracks";
  tracks: Track[] = [];

  constructor(
    private apiService: ApiService
  ) { }

  //---GET---//

  getTracks(query: QueryParams = {}): Observable<Track[]> {
    return this.apiService.getCollection(this.collectionPath, "", query);
  }

  getTrack(id: string): Observable<Track> {
    return this.apiService.getCollectionItem(this.collectionPath, "", id)
  }

  getValueList(field: string): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, "listValues", { field });
  }

  exportTracks(query: QueryParams = {}): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, "export", query);
  }

  getTracksByDb(idsByDb: Record<string, string[]> = {}): Observable<Track[]> {
    return this.apiService.getCollection(this.collectionPath, 'lastTracksByDb', idsByDb)
  }

  getDistance(tracker: string, startDate: string, endDate: string): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, 'distance', { tracker, startDate, endDate });
  }

  getAllByTimePeriod(chart: QueryParams): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, 'getAllByTimePeriod', { tracker: chart['tracker'], startDate: chart['startDate'], endDate: chart['endDate'], accuracy: chart['accuracy'] });
  }

  getPositionByTimePeriod(data: QueryParams): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, 'positionByTimePeriod', { tracker: data['tracker'], startDate: data['startDate'], endDate: data['endDate'], accuracy: data['accuracy'] });
  }

  getPositionAtTime(params: QueryParams): Observable<Record<string, Track[]>> {
    return this.apiService.getCollection(this.collectionPath, 'positionAtTime', params);
  } 

  //---POST---//

  addTrack(track: PostTrack): Observable<Track> {
    return this.apiService.postCollectionData(this.collectionPath, '', track);
  }

  addTracks(tracks: PostTrack[]): Observable<Track[]> {
    return this.apiService.postCollectionData(this.collectionPath, 'many', tracks);
  }

  addTrackVirtual(track: PostTrack): Observable<Track> {
    return this.apiService.postCollectionData(this.collectionPath, 'virtual', track);
  }

  getLastPositions(payload: { createdDate?: string, startDate?: string, endDate?: string, trackers: string[] }): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, 'lastPositions', payload);
  }

  //---PUT---//

  updateTrack(track: PutTrack): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath, track);
  }
  
  //---DELETE---//

  removeTrack(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }

  removeTracks(query: QueryParams = {}): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, "", query);
  }
}
